import { Pin } from 'lucide-react';

export default function PinButton({ pinned, label, onToggle, disabled }) {
  const action = `${pinned ? 'Unpin' : 'Pin'} ${label}`;
  return (
    <button type="button" aria-pressed={pinned} aria-label={action} title={action} disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      }}
      className={`absolute right-1.5 top-1/2 z-20 grid h-7 w-7 -translate-y-1/2 place-items-center rounded-lg outline-none transition-opacity hover:bg-[var(--sidebar-group-bg)] focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed disabled:opacity-40 ${
        pinned ? 'text-sidebar-active-ink opacity-100' : 'text-sidebar-ink-muted opacity-100 md:opacity-0 md:group-hover/item:opacity-100'
      }`}>
      <Pin className="h-3.5 w-3.5" fill={pinned ? 'currentColor' : 'none'} aria-hidden="true" />
    </button>
  );
}
